import {apiConstants, config, downloadBlob, requestOptions, requestTypes, sendRequest} from "../../../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************
class serverOrderManagementApi {
static getOrders(orderSearchCriteria: Record<string, unknown>) {
const queryParameters = new URLSearchParams(orderSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(`${config.URL}orders?${queryParameters}`,
                requestTypes.GET,
            )
        );
    }

    static cancelOrder(orderId: string) {
        return sendRequest(
            requestOptions(`${config.URL}orders/${orderId}/cancel`,
                requestTypes.PUT,
                null,
                apiConstants.successMessage.order.CANCEL
            ),
        );
    }

    static updateOrderNotes(orderId: string, notes: string) {
        return sendRequest(
            requestOptions(`${config.URL}orders/${orderId}/notes`,
                requestTypes.PUT,
                JSON.stringify({ notes }),
                "Successfully updated notes for the Order."
            ),
        );
    }

    static exportOrdersReport(orderSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(orderSearchCriteria as Record<string, string>).toString();
        return downloadBlob(
            requestOptions(config.URL + `reports/orders/export?${queryParameters}`,
                requestTypes.GET,
                null,
                apiConstants.successMessage.report.REPORT_DOWNLOADED,
            )
        );
    }

    static getDropdownListsForOrders() {
        return sendRequest(
            requestOptions(`${config.URL}orders/dropdown-lists`,
                requestTypes.GET,
            )
        );
    }
}

export const orderManagementApi = config.environment.MODE === config.modes.SERVER ? serverOrderManagementApi : serverOrderManagementApi;
